import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Box, Drawer, useMediaQuery, useTheme, } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useForm } from "react-hook-form";
import { PButton } from "@ui/components/buttons/PButton";
import { ArrowLeft2, Car, MessageQuestion, User, } from "iconsax-react";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { Steper } from "@ui/components/event/steper/Steper";
import { ConfirmDialog } from "../ConfirmDialog";
import { PersonalInfoForm } from "../PersonalInfo";
import { SuccessMsg } from "../SuccessMsg";
import { ExternalsForm } from "../ExternalsForm";
import { PersonalInfoRegistertionAsync } from "@application/features/personalInfo/personalInfoThunk";
import { Accommodation } from "../Accommodation";
import { TransportSelection } from "../Transport";
import { Icon } from "@iconify/react";
import { ImportantInfoForm } from "../ImportantInfo";
import { ArrowRightIcon, Building, DiamondIcon } from "@ui/icons/CustomIcons";
import { ImportantInfoRegistertionAsync } from "@application/features/importantInformation/importantInfoThunk";
import { CreateAccommodationAsync } from "@application/features/accommodation/accommodationThunk";
import { CreateTransportAsync } from "@application/features/transport/transportThunk";
import { FormWraper } from "@ui/components/event/wraper/FormWraper";
import { FormScrollable } from "@ui/components/event/wraper/FormScrollable";
import { useTranslation } from "react-i18next";
import { getInvitationDatesForByInvitationIdWithPreAccDateAsync } from "@application/features/invitation/invitationThunk";
import { useNavigate } from "react-router-dom";
import { InvitationStatusEnum } from "@application/common/enums/invitation-status-enum";
import { ExternalFormSummary } from "../ExternalFormSummary";
import { DirectorFormSummary } from "../DirectorFormSummary";
export const DirectorEvent = ({ handleLogoPosition }) => {
    const { personalInfo } = useAppSelector((state) => state.person);
    const [importantInfoId, setImportantInfoId] = useState(null);
    const [accommodationId, setAccommodationId] = useState(null);
    const [transportId, setTransportId] = useState(null);
    const [externalId, setExternalId] = useState(null);
    const [IsSuccess, setIsSuccess] = useState(false);
    const navigate = useNavigate();
    const { control, handleSubmit, setError, setValue, clearErrors, getValues, trigger, watch, reset, formState: { errors }, } = useForm({
        mode: "onChange",
    });
    const [formValues, setFormValues] = useState(null);
    const { linkVerification } = useAppSelector((state) => state.event);
    const { t } = useTranslation();
    const { accommodationInfo } = useAppSelector((state) => state.accommodation);
    const { transportInfo } = useAppSelector((state) => state.transport);
    const { importantInfo } = useAppSelector((state) => state.importantInfo);
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down("md"));
    const isMd = useMediaQuery(theme.breakpoints.down("lg"));
    const isAbove1024 = useMediaQuery("(min-width:1025px)");
    const isBelow390 = useMediaQuery("(max-width:391px)");
    const isTablet = useMediaQuery("(min-width:1024px)");
    const isOnly1152 = useMediaQuery(theme.breakpoints.between(1152, 1153)); // macbook screen size
    const searchParams = new URLSearchParams(location.search);
    const drawerParam = searchParams.get("drawer");
    const [open, setOpen] = useState(false);
    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };
    const watchedValues = watch();
    const dispatch = useAppDispatch();
    const [activeStep, setActiveStep] = useState(1);
    const [isConfirm, setisConfirm] = useState(false);
    const handleImportantInfoChange = (newId) => {
        setImportantInfoId(newId);
    };
    const handleAccommodationChange = (id) => {
        setAccommodationId(id);
    };
    const handleExternalChange = (id) => {
        setExternalId(id);
    };
    const handleTransportChange = (id) => {
        setTransportId(id);
    };
    const eventType = "directors";
    // useEffect(() => {
    //   dispatch(GetDietaryOptionsAsync());
    // }, [dispatch]);
    const handleNext = async () => {
        const isValid = await trigger();
        if (!isValid)
            return;
        await SaveFormData(activeStep, getValues());
        // setisConfirm(true);
        setActiveStep(activeStep + 1);
    };
    const handleBack = () => {
        if (activeStep === 1)
            return;
        setActiveStep(activeStep - 1);
    };
    const SaveFormData = async (step, formData) => {
        let stepData;
        switch (step) {
            case 1:
                stepData = {
                    ...formData.PersonalInfo,
                    Id: personalInfo?.id,
                    UserId: linkVerification?.data?.userId,
                    InvitationId: linkVerification?.data?.invitationId,
                    Option: 4,
                    ...(formData.PersonalInfo?.Option !== 1 && {
                        AdultsCount: Number(formData.PersonalInfo?.AdultsCount),
                    }),
                    ...(formData.PersonalInfo?.Option === 3 && {
                        ChildrenCount: Number(formData.PersonalInfo?.ChildrenCount),
                    }),
                    AttendanceDateIds: formData.PersonalInfo?.AttendanceDateIds,
                    WillYouAttendEvent: String(formData.PersonalInfo?.WillYouAttendEvent) === "true",
                    DateOfBirth: formData.PersonalInfo?.DateOfBirth
                        ? new Date(Date.UTC(new Date(formData.PersonalInfo.DateOfBirth).getFullYear(), new Date(formData.PersonalInfo.DateOfBirth).getMonth(), new Date(formData.PersonalInfo.DateOfBirth).getDate())).toISOString()
                        : null,
                };
                try {
                    await dispatch(PersonalInfoRegistertionAsync(stepData))
                        .unwrap()
                        .then((response) => {
                        if (response.invitationStatus == InvitationStatusEnum.Expired) {
                            navigate("/event/not-coming");
                        }
                    })
                        .finally(() => {
                        setActiveStep(5);
                    });
                }
                catch (error) { }
                break;
            case 2:
                stepData = {
                    ...formData.Accommodation,
                    Id: accommodationId ? accommodationId : undefined,
                    PersonId: personalInfo?.id,
                    AccommodationDates: formData?.Accommodation?.AccommodationDates,
                    OverNightStay: String(formData.Accommodation?.OverNightStay) === "true",
                };
                try {
                    await dispatch(CreateAccommodationAsync(stepData)).unwrap();
                }
                catch (error) { }
                break;
            case 3:
                stepData = {
                    ...formData.Transport,
                    Id: transportId ? transportId : undefined,
                    PersonId: personalInfo?.id,
                    DoYouWantTransport: formData?.Transport?.DoYouWantTransport,
                    TransportOption: formData?.Transport?.TransportOption
                        ? Number(formData?.Transport?.TransportOption)
                        : undefined,
                    IsParkingRequired: String(formData?.Transport?.IsParkingRequired) === "true",
                    TransportParkingDates: formData?.Transport?.TransportParkingDates,
                };
                try {
                    await dispatch(CreateTransportAsync(stepData)).unwrap();
                }
                catch (error) { }
                break;
            case 4:
                stepData = {
                    ...formData.ImportantInfo,
                    Id: importantInfoId,
                    UserId: linkVerification?.data?.userId,
                    InvitationId: linkVerification?.data?.invitationId,
                    Comments: formData.ImportantInfo?.Comments,
                    IsBusTransportRequired: String(formData.ImportantInfo?.IsBusTransportRequired) === "true",
                    IsDisability: String(formData.ImportantInfo?.IsDisability) === "true",
                    SeatsCount: Number(formData.ImportantInfo?.SeatsCount),
                    PersonId: personalInfo?.id,
                    DietaryRequirements: formData.ImportantInfo?.DietaryRequirements,
                    DisabilityComments: String(formData.ImportantInfo?.IsDisability) === "true"
                        ? formData.ImportantInfo?.DisabilityComments
                        : "",
                };
                try {
                    await dispatch(ImportantInfoRegistertionAsync(stepData))
                        .unwrap()
                        .then((response) => {
                        setActiveStep(5);
                        handleLogoPosition && handleLogoPosition("start");
                        setisConfirm(false);
                    });
                }
                catch (error) { }
                break;
            default:
        }
    };
    const validateImportantInfo = async () => {
        const isValid = await trigger();
        if (!isValid)
            return;
        if (personalInfo?.invitationStatus !== 3) {
            setisConfirm(true);
        }
        else {
            setActiveStep(6);
        }
    };
    const onSubmit = () => {
        if (personalInfo?.invitationStatus === 3) {
            setIsSuccess(true);
            setisConfirm(false);
        }
        else {
            SaveFormData(activeStep, getValues());
        }
    };
    const steps = [
        { description: t("event.personalInfo"), icon: _jsx(User, {}) },
        { description: t("event.accomodationInfo"), icon: _jsx(Building, {}) },
        { description: t("event.transportInfo"), icon: _jsx(Car, {}) },
        { description: t("event.importantInfo"), icon: _jsx(MessageQuestion, {}) },
        { description: t("event.thankyou"), icon: _jsx(Icon, { icon: "hugeicons:gift" }) },
        { description: t("event.externalsInfo"), icon: _jsx(DiamondIcon, {}) },
    ];
    useEffect(() => {
        if (drawerParam === "external") {
            setActiveStep(6);
        }
        const personInfo = watchedValues.PersonalInfo;
        if (linkVerification?.data?.invitationId)
            dispatch(getInvitationDatesForByInvitationIdWithPreAccDateAsync(linkVerification?.data?.invitationId));
    }, [
        linkVerification?.data?.invitationId,
        accommodationInfo,
        transportInfo,
        importantInfo,
        drawerParam,
    ]);
    useEffect(() => {
        const container = document.querySelector(".events__main-content-wrapper");
        if (container) {
            container.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
    }, [activeStep]);
    return (_jsxs(Box, { children: [activeStep === 5 ? (_jsx(SuccessMsg, { onClick: () => setActiveStep(6), eventType: eventType })) : (_jsxs(Grid, { container: true, spacing: isBelow390 ? 8 : isAbove1024 ? 15 : 2.5, justifyContent: "space-between", p: 0, children: [_jsxs(Grid, { size: { xs: 12, sm: 12, md: isTablet ? 7 : 12, lg: 7 }, sx: {
                            position: isTablet && activeStep === 6 ? "sticky" : 'static',
                            top: isTablet ? '120px' : '104px',
                            alignSelf: "flex-start", // ensures sticky works inside flex/grid layouts
                        }, children: [_jsx(Steper, { activeStep: activeStep, eventType: eventType, steps: steps }), _jsx(FormWraper, { children: activeStep < 7 && (_jsxs(FormScrollable, { children: [activeStep === 1 && (_jsx(PersonalInfoForm, { control: control, eventType: eventType, errors: errors, personId: personalInfo?.id, setValue: setValue, setError: setError, clearErrors: clearErrors })), activeStep === 2 && (_jsx(Accommodation, { control: control, errors: errors, eventType: eventType, personId: personalInfo?.id, setValue: setValue, onAccommodationChange: handleAccommodationChange })), activeStep === 3 && (_jsx(TransportSelection, { control: control, errors: errors, eventType: eventType, personId: personalInfo?.id, setValue: setValue, onTransportChange: handleTransportChange })), activeStep === 4 && (_jsx(ImportantInfoForm, { control: control, eventType: eventType, errors: errors, onImportantInfoChange: handleImportantInfoChange, personId: personalInfo?.id, setValue: setValue })), activeStep === 6 && (_jsx(ExternalsForm, { personId: personalInfo?.id, reset: reset, setValue: setValue, onExternalChange: handleExternalChange })), activeStep < 5 && (_jsxs(Box, { mt: 3, display: "flex", flexDirection: { xs: "column-reverse", lg: "row" }, gap: 1, children: [activeStep >= 2 && (_jsx(PButton, { variant: "outlined", color: "ePrimary", fullWidth: true, onClick: handleBack, startIcon: _jsx(ArrowLeft2, {}), width: isMd ? "100%" : 160, minWidth: isMd ? "100%" : 160, maxWidth: isMd ? "100%" : 160, children: t("actions.back") })), activeStep !== 4 && (_jsx(PButton, { endIcon: _jsx(ArrowRightIcon, {}), fullWidth: true, variant: "contained", color: "ePrimary", onClick: handleNext, children: t("actions.saveAndNext") })), activeStep === 4 && (_jsx(PButton, { fullWidth: true, color: "ePrimary", endIcon: _jsx(ArrowRightIcon, {}), onClick: validateImportantInfo, children: t("actions.submitAll") }))] }))] })) })] }), _jsx(Grid, { size: { xs: 12, sm: 12, md: isTablet ? 5 : 12, lg: 5 }, children: activeStep === 6 ? (_jsx(ExternalFormSummary, { activeStep: activeStep, watchedValues: watchedValues })) : (_jsx(DirectorFormSummary, { activeStep: activeStep, watchedValues: watchedValues })
                        // <FormSummary
                        //   activeStep={activeStep}
                        //   watchedValues={watchedValues}
                        // />
                        ) })] })), _jsx(Drawer, { open: open, anchor: "right", onClose: toggleDrawer(false), children: _jsx(Box, { width: 330, px: 1, children: _jsx(DirectorFormSummary, { activeStep: activeStep, isDrawer: true, watchedValues: watchedValues }) }) }), _jsx(ConfirmDialog, { isOpen: isConfirm, onConfirm: handleSubmit(onSubmit), onClose: () => setisConfirm(false), bodyText: t("event.configDialogText"), title: t("event.submitAllInformation") })] }));
};
